import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { Observable } from "rxjs";

import { CountrySelectorData } from "@hermes/api-model-country";
import { Settings } from "@hermes/core-app-core";
import { SKIP_404_INTERCEPTOR } from "@hermes/utils-generic-constants";

@Injectable()
export class FetchCountriesService {
    private http = inject(HttpClient);
    private settings = inject(Settings);

    public fetchCountries(): Observable<CountrySelectorData> {
        return this.http.get<CountrySelectorData>(
            `${this.settings.apiUrl}/country-selector`,
            {
                context: new HttpContext().set(SKIP_404_INTERCEPTOR, true),
            },
        );
    }
}
